let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("RjJJx")).then(() => parcelRequire('6ugDe'));